import { render, staticRenderFns } from "./RuleManagerDirectMatch.vue?vue&type=template&id=6592eca4&scoped=true&"
import script from "./RuleManagerDirectMatch.vue?vue&type=script&lang=js&"
export * from "./RuleManagerDirectMatch.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerDirectMatch.vue?vue&type=style&index=0&id=6592eca4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592eca4",
  null
  
)

export default component.exports